// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"ee00f8f2","952":"46e00cb3"}[chunkId] + ".chunk.js";
};